import React, { useRef, useState } from 'react';
import { Box, Grid, Icons, Tooltip, Typography } from '@curves/ui-base';

import { ChartProvider } from "@Local/Dashboard/Components/ChartContext";
import { ChartAdvancedContent, ChartAdvancedBar } from "@Local/Dashboard/Components/ChartAdvancedFilter/";
import { ChartDialogBox } from "@Local/Dashboard/Dialog";

import { chartTypeMap, dataTypeMap } from "@Local/Dashboard/staticData";
const ChartAdvancedFilterPage = () => {
    const [openSearch, setOpenSearch] = useState(true);
    const [dataType, setDataType] = useState(dataTypeMap.tagged);
    const [chartType, setChartType] = useState(chartTypeMap.bar);
    const [sourceData, setSourceData] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState([]);
    const [selectedStatistics, setSelectedStatistics] = useState([]);
    const dialogRef = useRef(null);
    const refreshRef = useRef(null);
    const SlideIcon = openSearch ? Icons.LastPage : Icons.FirstPage;
    const childContext = {
        dataType,
        setDataType,
        chartType,
        setChartType,
        sourceData,
        setSourceData,
        openSearch,
        getDialog: () => dialogRef.current,
        setDialogRef: (el) => (dialogRef.current = el),
        selectedFilter,
        setSelectedFilter,
        selectedStatistics,
        setSelectedStatistics,
        refresh: () => typeof refreshRef.current === 'function' && refreshRef.current(),
        setRefreshRef: (fn) => (refreshRef.current = fn),
    };
    return (
        <ChartProvider value={childContext}>
            <Box className="container main-container-spacing points-redeem-container">
                <header className={'page-header'}>
                    <Grid container spacing={2}>
                        <Grid item xs={9}>
                            <Typography className={'page-header-title'} variant={'h3'}>
                                進階查詢
                            </Typography>
                        </Grid>
                        <Grid item xs={3} className={'text-right'}>
                            <Tooltip disableFocusListener title={openSearch ? '收合' : '展開'}>
                                <SlideIcon fontSize={'large'}
                                           color={'primary'}
                                           onClick={() => setOpenSearch(!openSearch)}
                                />
                            </Tooltip>
                        </Grid>
                    </Grid>
                </header>
                <Grid container spacing={2}>
                    <Grid item xs={openSearch ? 9 : 12}>
                        <ChartAdvancedContent />
                    </Grid>
                    <Grid item xs={openSearch ? 3 : 0} style={{ display: `${openSearch ? 'block' : 'none'}` }}>
                        <ChartAdvancedBar />
                    </Grid>
                </Grid>
                <Box></Box>
                <ChartDialogBox ref={dialogRef} />
            </Box>
        </ChartProvider>
    )
}
export default ChartAdvancedFilterPage;